import Constant from '@/const';
import axios from 'axios';

const getLabResult = async idLab => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/supportservice/laboratory/result/${idLab}`),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getLabResult;
